import React from 'react';
import { ui } from '../../styles/shared';

// Stilar från den gemensamma stilfilen
const card = ui.card;
const btn = ui.btn;

interface Props {
    targetTemp: number;
    onTempChange: (t: number) => void;
    onApply: (t: number) => void;
    readOnly?: boolean;
}

const ThermostatControl: React.FC<Props> = ({ targetTemp, onTempChange, onApply, readOnly }) => (
    <div style={card}>
        <h3 style={{ marginTop: 0 }}>🌡️ Styr termostat</h3>
        <div style={{ marginBottom: '20px' }}>
            <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '10px' }}>
                Önskad temperatur: {targetTemp} °C
            </label>
            {!readOnly && (
                <>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <button onClick={() => onTempChange(Math.max(15, targetTemp - 1))}
                            style={{ ...btn('#007bff'), padding: '10px 15px', fontSize: '18px' }}>-</button>
                        <input type="number" min="15" max="30" value={targetTemp}
                            onChange={e => onTempChange(Number(e.target.value))}
                            style={{ padding: '10px', fontSize: '18px', width: '80px', textAlign: 'center', border: '1px solid #ddd', borderRadius: '4px' }} />
                        <button onClick={() => onTempChange(Math.min(30, targetTemp + 1))}
                            style={{ ...btn('#007bff'), padding: '10px 15px', fontSize: '18px' }}>+</button>
                    </div>
                    <button onClick={() => onApply(targetTemp)}
                        style={{ ...btn('#28a745'), marginTop: '10px', padding: '8px 16px' }}>Spara temperatur</button>
                </>
            )}
        </div>
    </div>
);

export default ThermostatControl;
